// アクティブ状態を切り替えるための抽象クラス
// サブクラスで `toActive()` と `toDefault()` を実装して
// 動作を定義する
export default class AbstractSwitch {
  constructor(options) {
    this.isActive = false
    this.config = AbstractSwitch.mergeSettings(options)

    if (this.config.trigger === null || this.config.targets.some(e => e === null)) {
      throw new Error('Something wrong with your selector.')
    }

    this.config.trigger.addEventListener('click', () => this.switch())
  }

  static mergeSettings(options) {
    const settings = {
      trigger: null,
      targets: [],
      onActive: (...args) => null,
      onDefault: (...args) => null
    }
    return Object.assign({}, settings, options)
  }

  switch() {
    if (this.isActive) {
      this.toDefault()
      this.config.onDefault(this.config.trigger, this.config.targets)
    } else {
      this.toActive()
      this.config.onActive(this.config.trigger, this.config.targets)
    }
  }

  toActive() {
    this.isActive = true
  }

  toDefault() {
    this.isActive = false
  }
}
